var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main1"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('musician-list',{attrs:{"type":'2',"index":index,"dataObj":item},on:{"openAlert":_vm.openAlert,"outGroup":_vm.outGroupUser}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }